import { c as _c } from "react/compiler-runtime";
import { type ButtonProps, buttonVariants, Icon } from '@repo/ui';
import { BurgerMenu, Chevron, Morpho, MorphoGradient } from '@repo/ui/icons';
import { useState } from 'react';
import MenuDropdown from '../MenuDropdown';
import { MorphoTextSvg } from '../MorphoTextSvg';
export interface MenuButtonProps {
  variant?: ButtonProps['variant'];
}
const MenuButton = t0 => {
  const $ = _c(17);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "secondary" : t1;
  const [isOpen, setIsOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon icon={<MorphoGradient />} className="size-[28px] dark:hidden" aria-hidden={true} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon icon={<Morpho />} className="hidden size-[28px] dark:block" aria-hidden={true} />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== variant) {
    t4 = buttonVariants({
      variant,
      size: "icon"
    });
    $[2] = variant;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <BurgerMenu />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4) {
    t6 = <span className="lg:hidden"><span aria-hidden="true" className={t4}>{t5}</span></span>;
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span aria-hidden="true"><MorphoTextSvg /></span>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Chevron />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = `text-foreground size-5 transition-transform duration-200 ${isOpen ? "rotate-180" : "rotate-0"}`;
  let t10;
  if ($[9] !== t9) {
    t10 = <span className="gap-xs hidden items-center lg:flex">{t7}<Icon icon={t8} aria-hidden={true} className={t9} /></span>;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t6) {
    t11 = <button type="button" aria-label="Morpho menu" className="gap-xs focus-visible:ring-ring m-0 flex cursor-pointer items-center rounded-lg border-none bg-transparent p-0 text-inherit outline-hidden focus-visible:ring-[2px] max-lg:gap-[18px]">{t2}{t3}{t6}{t10}</button>;
    $[11] = t10;
    $[12] = t6;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== isOpen || $[15] !== t11) {
    t12 = <MenuDropdown isOpen={isOpen} onOpenChange={setIsOpen} trigger={t11} />;
    $[14] = isOpen;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
};
export default MenuButton;